module.exports = __webpack_public_path__ + "static/media/thumb-coingossip.35905257.png";